export const METRICS = [
  ["login_auth", "Login auth", "#8b5cf6"],
  ["login_guest", "Login guest", "#64748b"],
  ["click_obloane", "Click Obloane", "#f59e0b"],
  ["click_scanx", "Click ScanX", "#10b981"],
  ["click_config", "Click Configurator", "#a855f7"],
  ["oferte_oblon", "Oferte Oblon", "#f97316"],
  ["oferte_scanx", "Oferte ScanX", "#10b981"],
  ["oferte_config", "Oferte Configurator", "#6d28d9"],
  ["utilizatori_distrib", "Utilizatori noi distribuitori", "#e11d48"],
  ["utilizatori_guest", "Utilizatori noi guest", "#dc2626"],
  ["click_simpl_oblon", "Click Simpl. Oblon", "#fb923c"],
  ["click_simpl_fu", "Click Simpl. Fer/Usi", "#fdba74"],
  ["oferte_simpl_oblon", "Oferte Simpl. Oblon", "#ea580c"],
  ["oferte_simpl_fu", "Oferte Simpl. Fer/Usi", "#c2410c"],
  ["click_simpl_constructii", "Click Simpl. Fundatii", "#0d9488"],
  ["click_config_constructii", "Click Config. Fundatii", "#c026d3"],
  ["login_total", "Login total (auth + guest)", "#0ea5e9"],
  ["oferte_total", "Total oferte (toate 5)", "#16a34a"],
];

export const sel = "rounded border border-slate-300 bg-white px-2 py-1.5 text-sm";
